// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Divider } from '@livechat/design-system'
import IntegrationApiClient from '../api/integration'

const Account = ({ auth, onDisconnected }) => {
  const [isDisconnecting, setIsDisconnecting] = useState(false)
  const integrationApi = new IntegrationApiClient()

  const uninstall = async () => {
    setIsDisconnecting(true)

    try {
      await integrationApi.uninstallSlack(
        auth.firebaseToken,
        auth.slack.user_access_token,
        auth.slack.bot_access_token,
        auth.appName
      )
      setIsDisconnecting(false)
      onDisconnected(true)
    } catch (err) {
      setIsDisconnecting(false)
      console.error(err)
    }
  }

  return (
    <div
      css={css`
        padding: 20px;
      `}
    >
      <div>
        <div
          css={css`
            margin-bottom: 15px;
          `}
        >
          <h5
            css={css`
              font-size: 16px;
              line-height: 24px;
              font-weight: 600;
              margin-top: 0;
              margin-bottom: 0;
            `}
          >
            Status
          </h5>
          <Divider />
          <div>
            You are connected to <strong>{auth.slack.team.name}</strong> (
            <a
              href={`https://${auth.slack.team.domain}.slack.com`}
              target="_blank"
              rel="noopener noreferrer"
            >{`${auth.slack.team.domain}.slack.com`}</a>
            ) workspace.
          </div>
        </div>

        <h5
          css={css`
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
            margin-bottom: 0;
          `}
        >
          Manage
        </h5>

        <Divider />

        <div
          css={css`
            margin-bottom: 15px;
          `}
        >
          Please be aware, that when you disconnect your Slack workspace you
          won’t be able to receive notifications and messages.
        </div>

        <Button destructive onClick={uninstall} loading={isDisconnecting}>
          Disconnect from Slack
        </Button>
      </div>
    </div>
  )
}

export default Account
